import { render, staticRenderFns } from "./PhoneOrders.vue?vue&type=template&id=2dc95492&scoped=true"
import script from "./PhoneOrders.vue?vue&type=script&lang=js"
export * from "./PhoneOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc95492",
  null
  
)

export default component.exports